import { render } from "./TypingIndicator.vue?vue&type=template&id=5d210510&scoped=true"
const script = {}

import "./TypingIndicator.vue?vue&type=style&index=0&id=5d210510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d210510"]])

export default __exports__